import {
  ACCESS_TOKEN,
  IS_BUY_FIRST_SHARES,
  IS_DEPOSIT_ETH,
  IS_VERIFY_TIKTOK,
  REFERRER_ID,
  deleteItem,
  getItem,
  saveItem,
} from "local-storage";
import React, { createContext, useCallback, useContext, useState } from "react";

const AuthContext = createContext<any>(null);

export function AuthProvider({ children }: any) {
  const accessToken = getItem(ACCESS_TOKEN);
  const currentReferrerId = getItem(REFERRER_ID);
  const currentIsVerifyTiktok = getItem(IS_VERIFY_TIKTOK);
  const currentIsDepositEth = getItem(IS_DEPOSIT_ETH);
  const currentIsBuyFirstShares = getItem(IS_BUY_FIRST_SHARES);

  const [token, setToken] = useState(accessToken || "");
  const [referrerId, setReferrerId] = useState<null | string>(
    currentReferrerId || ""
  );
  const [isVerifyTiktok, setIsVerifyTiktok] = useState<null | string>(
    currentIsVerifyTiktok || ""
  );
  const [isDepositEth, setIsDepositEth] = useState<null | string>(
    currentIsDepositEth || ""
  );
  const [isBuyFirstShares, setIsBuyFirstShares] = useState<null | string>(
    currentIsBuyFirstShares || ""
  );
  const updateToken = (newValue: string) => {
    setToken(newValue);
    saveItem(ACCESS_TOKEN, newValue);
  };

  const updateReferrerId = (newValue: string) => {
    setReferrerId(newValue);
    saveItem(REFERRER_ID, newValue);
  };

  const updateIsVerifyTiktok = useCallback((newValue: string) => {
    setIsVerifyTiktok(newValue);
    saveItem(IS_VERIFY_TIKTOK, newValue);
  }, []);

  const updateIsDepositEth = useCallback((newValue: string) => {
    setIsDepositEth(newValue);
    saveItem(IS_DEPOSIT_ETH, newValue);
  }, []);

  const updateIsBuyFirstShares = useCallback((newValue: string) => {
    setIsBuyFirstShares(newValue);
    saveItem(IS_BUY_FIRST_SHARES, newValue);
  }, []);

  const handlelogout = () => {
    setToken("");
    setReferrerId("");
    setIsVerifyTiktok("");
    setIsDepositEth("");
    setIsBuyFirstShares("");
    deleteItem();
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        updateToken,
        referrerId,
        updateReferrerId,
        updateIsVerifyTiktok,
        isVerifyTiktok,
        isDepositEth,
        updateIsDepositEth,
        isBuyFirstShares,
        updateIsBuyFirstShares,
        handlelogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
